// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import "babel-polyfill";
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";

import "fullpage-vue/src/fullpage.css";
import VueFullpage from "fullpage-vue";
import VModal from "vue-js-modal";
import VueGtag from 'vue-gtag'


import pm from "./components/common/protocolManager";



import "./assets/css/common.css";
import "./assets/css/gnb.css";
import "./assets/css/main.css";
import "./assets/css/sub.css";

import "animate.css";


// import './assets/css/vue2-editor.css';
// import '../node_modules/quill/dist/quill.core.css';
// import '../node_modules/quill/dist/quill.bubble.css';
import '../node_modules/quill/dist/quill.snow.css';


import Downloader from "js-file-downloader";



Vue.use(VModal, {
  // dialog: true,
  dynamic: true,
  dynamicDefaults: {
    clickToClose: false
  }
});

Vue.config.productionTip = false;

Vue.prototype.fileDownload = function(fileUrl) {
  console.log("filedownload = " + location.origin + "/static" + fileUrl);

  new Downloader({
    url: location.origin + "/static" + fileUrl
  })
    .then(() => {
      console.log("fileDownload ok");
    })
    .catch(err => {
      console.log("fileDownload err = " + err);
      console.log("fileDownload url = " + fileUrl);
    });
};

Vue.prototype.nasDownload = function(fileUrl) {
  console.log("nasDownload = " + pm.NAS_URL + fileUrl);

  new Downloader({
    url: pm.NAS_URL + fileUrl
  })
    .then(() => {
      console.log("nasDownload ok");
    })
    .catch(err => {
      console.log("nasDownload err = " + err);
      console.log("nasDownload url = " + fileUrl);
    });
};

String.prototype.string = function(len) {
  var s = "",
    i = 0;
  while (i++ < len) {
    s += this;
  }
  return s;
};
String.prototype.zf = function(len) {
  return "0".string(len - this.length) + this;
};
Number.prototype.zf = function(len) {
  return this.toString().zf(len);
};

Vue.filter("date", function (date) {
  if (date == "") {
    return "";
  }
  let retVal = new Date(date);

  // return `${retVal.getFullYear()}-${(retVal.getMonth() + 1).zf(2)}-${retVal.getDate().zf(2)} ${retVal.getHours().zf(2)}:${retVal.getMinutes().zf(2)}`;
  return `${retVal.getFullYear()}-${(retVal.getMonth() + 1).zf(2)}-${retVal.getDate().zf(2)}`;
});

Vue.filter("formatSize", function(size) {
  if (size !== undefined) {
    if (size > 1024 * 1024 * 1024 * 1024) {
      return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + " TB";
    } else if (size > 1024 * 1024 * 1024) {
      return (size / 1024 / 1024 / 1024).toFixed(2) + " GB";
    } else if (size > 1024 * 1024) {
      return (size / 1024 / 1024).toFixed(2) + " MB";
    } else if (size > 1024) {
      return (size / 1024).toFixed(2) + " KB";
    }
    return size.toString() + " B";
  }
});

Vue.use(VueFullpage);

Vue.use(VueGtag, {
    config: {
        id: '	G-NY3NGMG2WJ'  // Google Analytics의 Tracking ID를 넣어준다
    }
});


//new Vue({ i18n }).$mount("#app");

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
  data: function() {
    return {
      isMobileMode: false,
      windowWidth: 0,
      windowHeight: 0
    };
  },

  mounted() {
    this.$nextTick(function() {
      window.addEventListener("resize", this.getWindowWidth);
      window.addEventListener("resize", this.getWindowHeight);

      //Init
      this.getWindowWidth();
      this.getWindowHeight();
    });
  },

  methods: {
    getWindowWidth(event) {
      this.windowWidth = document.documentElement.clientWidth;
    },

    getWindowHeight(event) {
      this.windowHeight = document.documentElement.clientHeight;
      if (this.windowWidth <= 1024) {
        this.isMobileMode = true;
      } else {
        this.isMobileMode = false;
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowWidth);
    window.removeEventListener("resize", this.getWindowHeight);
  }
});



// WEBPACK FOOTER //
// ./src/main.js